import React from 'react'
import parseExcelFields from 'utilities/parse-excel-fields' // function to parse excel data
import { read as xlsxRead, utils as xlsxUtils } from 'xlsx'

function useParseExcel(_props) {
  const {
    onSuccess = () => {},
    onError = () => {},
    columnDefinition: excelFileColumnDefinition = [],
  } = _props

  const [parsedData, setParsedData] = React.useState({
    complete: [],
    incomplete: [],
    invalid: [],
    dateInvalid: [],
    error: [],
  })

  function handleFile(file) {
    /* Boilerplate to set up FileReader */

    const reader = new FileReader()
    const rABS = !!reader.readAsBinaryString
    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result
      const wb = xlsxRead(bstr, { type: rABS ? 'binary' : 'array' })
      /* Get first worksheet */
      const wsname = wb.SheetNames[0]
      const ws = wb.Sheets[wsname]
      /* Convert array of arrays */
      const data = xlsxUtils.sheet_to_json(ws, { header: 1 })
      /* Update state */
      let {
        complete = [],
        incomplete = [],
        invalid = [],
        dateInvalid = [],
        error = [],
        total = 0,
      } = parseExcelFields(data, excelFileColumnDefinition)
      setParsedData({
        complete,
        incomplete,
        invalid,
        dateInvalid,
        error,
        total,
      })
      if (error.length === 0) {
        try {
          // If no errors were found while parsing
          onSuccess({
            complete,
            incomplete,
            invalid,
            dateInvalid,
            error,
            total,
          })
        } catch (error) {
          throw new Error('No function to store parsed data present')
        }
      }
    }
    if (rABS) reader.readAsBinaryString(file)
    else reader.readAsArrayBuffer(file)
  }

  return [parsedData, handleFile]
}

export default useParseExcel
